/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const FaqFragment = {
  FAQ: gql`
    fragment FaqQuery on aarpFaq_Entry {
      answerOverride {
        ... on answerOverrideBlock_Entry {
          questionNumber
          state
          override {
            html
          }
        }
      }
      backgroundImage {
        url
        ... on images_Asset {
          altText
        }
      }
      faqSubTitle
      faqTitle
      styles
      typeHandle
    }
  `,
};
